var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-app',[_c('v-content',[_c('div',{attrs:{"id":"mapcontainer"}},[_c('div',{attrs:{"id":"map"}})]),_c('Index',{ref:"index"})],1)],1),_c('legends',{ref:"legendsPane"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }